import { render, staticRenderFns } from "./DiyoboCheckbox.vue?vue&type=template&id=593c6e61&scoped=true"
import script from "./DiyoboCheckbox.vue?vue&type=script&lang=js"
export * from "./DiyoboCheckbox.vue?vue&type=script&lang=js"
import style0 from "./DiyoboCheckbox.vue?vue&type=style&index=0&id=593c6e61&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "593c6e61",
  null
  
)

export default component.exports